/* global $, APP, AccessBellMeetJS, config, interfaceConfig */

import React from 'react';
import { Button } from '@material-ui/core';

import { AbstractWelcomePage } from '../../../welcome/components/AbstractWelcomePage';

import { UnauthorizedIcon } from '../../../base/icons';


class UnauthorizedConference extends AbstractWelcomePage {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className = "inlay" style={{display: "flex", flexDirection: "column", justifyContent: "center", width: '100%', top: '-30%', height: '100%', position: 'absolute' }}>
                <div style={{display: "flex", flexDirection: "column", justifySelf: "center", alignSelf: "center", justifyContent: "center", width: '350px'}}>
                    <UnauthorizedIcon />
                </div>
                <h3 className = 'inlay__title' style={{marginTop: "20px"}}>
                    You are not authorized to join this meeting.
                </h3>
                <Button variant="contained" color="primary" onClick={() => {window.location.href = "/";}} style={{marginTop: "20px", display: "flex", flexDirection: "column", justifySelf: "center", alignSelf: "center", justifyContent: "center", width: 40 + "%"}}>
                    Exit
                </Button>
            </div>
        )
    }
}

export default UnauthorizedConference;